export default "__VITE_ASSET__BbQ$Lxta__"